import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { BusinessProductExpediterInvoiceListPage } from '../business-product-expediter-invoice-list/business-product-expediter-invoice-list';
import { ConsumerProfilePage } from '../../pages/consumer-profile/consumer-profile';


@Component({
  selector: 'page-expeditor-main',
  templateUrl: 'expeditor-main.html',
})
export class ExpeditorMainPage {
  invoices = BusinessProductExpediterInvoiceListPage;
  profile = ConsumerProfilePage;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ExpeditorMainPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/expeditor-main/expeditor-main.ts